import { MemberInterface } from './member.interface';
import { AddressInterface } from './address.interface';
import { ContactInterface } from '@app/interfaces/contact.interface';

export interface HouseholdInterface {
    _id: string;
    address: AddressInterface;
    members: MemberInterface[];
    type: string;
}

export interface AugmentedHouseholdInterface extends HouseholdInterface {
    contacts: string[];
    offer: string;
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
interface HouseholdIdToApplicants {
    [householdId: string]: ContactInterface[];
}

export class ApplicantsAwareHousehold implements HouseholdInterface {
    // tslint:disable-next-line:variable-name
    public _id: string;
    public address: AddressInterface;
    public applicants: string[];
    public members: MemberInterface[];
    public type: string;

    constructor(sourceHousehold: HouseholdInterface, applicants: ContactInterface[]) {
        return { ...sourceHousehold, applicants: applicants.map((applicant) => applicant._id) };
    }

    public static isApplicantsAwareHousehold(object: any): object is ApplicantsAwareHousehold {
        return object && !!object.applicants;
    }

    /**
     * Load assigned contacts to households
     */
    public static getEnrichedHouseholds(
        households: HouseholdInterface[],
        contactsPool: ContactInterface[]
    ): ApplicantsAwareHousehold[] {
        return households.map(
            (household) =>
                new ApplicantsAwareHousehold(
                    household,
                    contactsPool.filter((applicant) => applicant.households?.includes(household._id))
                )
        ); // enrich households of contacts
    }
}
